import React from "react";
import ReactDOM from "react-dom/client";

import 'bootstrap/dist/css/bootstrap.css';
import "./assets/css/fontawesome.min.css";
import "./assets/css/magnific-popup.min.css";
import "./assets/css/slick.min.css";
import "./assets/css/nice-select.min.css";
import "./assets/css/swiper-bundle.min.css";
import "./assets/css/style.css";
import "./assets/css/style.css.map";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import 'bootstrap/dist/js/bootstrap.js';
import App from "./App.js";



const rootElement = document.getElementById("root");

if (!rootElement) {
    console.error("Root element not found! Make sure you have <div id='root'></div> in /");
} else {
    const root = ReactDOM.createRoot(rootElement);
    root.render(<App />);
}
